import { defineComponent as N, ref as m, computed as T, watch as k, createElementBlock as i, openBlock as n, withKeys as v, createVNode as S, createBlock as _, createElementVNode as o, unref as c, withCtx as y, Fragment as B, renderList as E, createTextVNode as b, toDisplayString as x } from "vue";
import { useDebounceFn as j } from "@vueuse/core";
import { Client as q } from "typesense";
import { useRouter as A } from "vue-router";
import { useLoadingState as D, ScalarSearchInput as F, ScalarLoading as H, ScalarSearchResultList as P } from "@scalar/components";
import Q from "./TypesenseSearchResult.vue.js";
const z = {
  key: 0,
  class: "guides-search-empty-state"
}, O = {
  key: 1,
  class: "guides-search-empty-state"
}, U = {
  key: 2,
  class: "guides-search-loading"
}, ee = /* @__PURE__ */ N({
  __name: "TypesenseSearch",
  props: {
    typesenseKey: {},
    typesenseHost: {},
    typesenseCollection: {}
  },
  emits: ["close"],
  setup(g, { emit: C }) {
    const u = g, K = C, { resolve: V, push: $ } = A(), L = {
      query_by: "page_content",
      highlight_affix_num_tokens: 6,
      per_page: 24
    }, d = D(), R = new q({
      apiKey: u.typesenseKey,
      // Be sure to use the search-only-api-key fo typesense
      nodes: [
        {
          host: u.typesenseHost,
          port: 443,
          protocol: "https"
        }
      ],
      connectionTimeoutSeconds: 2
    }), a = m([]), l = m(""), r = m(0), p = T(
      () => a.value[r.value]
    ), I = j(async (s) => {
      const t = await R.collections(u.typesenseCollection).documents().search({ q: s, ...L });
      d.clear(), a.value = (t.hits || []).map((e) => ({
        ...e.document,
        uid: `search-result-${e.document.page_uid}`,
        snippet: e.highlight.page_content?.snippet,
        route: V({
          name: e.document.page_uid,
          params: {
            project: e.document.project_uid,
            version: e.document.version_uid,
            guide: e.document.guide_uid
          }
        })
      }));
    }, 325);
    k(l, async (s) => {
      s && u.typesenseKey ? (d.start(), I(s)) : a.value = [];
    }), k(p, (s) => {
      !document || !s || document.getElementById(s.uid)?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    });
    function h(s) {
      const t = r.value, e = a.value.length;
      r.value = (t + e + s) % e;
    }
    function f(s) {
      p.value && ($(s ?? p.value.route), K("close"));
    }
    return (s, t) => (n(), i("div", {
      class: "guides-search",
      onKeydown: [
        t[1] || (t[1] = v((e) => h(1), ["down"])),
        t[2] || (t[2] = v((e) => f(), ["enter"])),
        t[3] || (t[3] = v((e) => h(-1), ["up"]))
      ]
    }, [
      S(c(F), {
        modelValue: l.value,
        "onUpdate:modelValue": t[0] || (t[0] = (e) => l.value = e)
      }, null, 8, ["modelValue"]),
      g.typesenseKey ? l.value.length ? c(d).isLoading ? (n(), i("div", U, [
        S(c(H), {
          isLoading: "",
          size: "md"
        })
      ])) : (n(), _(c(P), {
        key: 3,
        class: "guides-search-results custom-scroll",
        noResults: !a.value.length
      }, {
        query: y(() => [
          b(x(l.value), 1)
        ]),
        default: y(() => [
          (n(!0), i(B, null, E(a.value, (e, w) => (n(), _(Q, {
            id: e.uid,
            key: `${w}${e.page_uid}`,
            active: r.value === w,
            snippet: e.snippet,
            onClick: (G) => f(e.route)
          }, {
            default: y(() => [
              b(x(e.page_title), 1)
            ]),
            _: 2
          }, 1032, ["id", "active", "snippet", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["noResults"])) : (n(), i("div", O, [...t[5] || (t[5] = [
        o("div", null, "Type Query Above", -1)
      ])])) : (n(), i("div", z, [...t[4] || (t[4] = [
        o("div", null, " On your published sites your content will be fully searchable allowing users to move around your documents with ease ✨ ", -1)
      ])])),
      t[6] || (t[6] = o("div", { class: "guides-search-meta" }, [
        o("span", {
          "aria-hidden": "true",
          class: "contents"
        }, [
          o("span", null, "↑↓ Navigate"),
          o("span", null, "⏎ Select")
        ]),
        o("span", { class: "sr-only" }, " Press up arrow / down arrow to navigate, enter to select, type to filter results ")
      ], -1))
    ], 32));
  }
});
export {
  ee as default
};
